import type { MouseEvent } from 'react'
import {
  hoverMenuItem,
  switchToBrand,
  toggleEditButtonGroup,
} from '@/msgdeskRuntime/legacyBridge/legacyActions'
import { dispatchDeskNavigation } from '@/msgdeskRuntime/deskNavigation'
import { getMsgDeskRuntime } from '@/msgdeskRuntime'
import { dispatchEditorAction } from '@/msgdeskRuntime/editorActions'
import { showQuickReplyModal } from '@/deskUiSkeletons/Shared/QuickReplyModal'
import type { PortalMenuActionLabels } from './types'

// Behaviour handlers shared by the menu (Sidebar) components. Every legacy call
// lives here as a named function so the menu markup stays declarative and any
// menu component can add/replace actions without decoding mev_* names in JSX.

export function handleMenuItemOver(event: MouseEvent<HTMLElement>, isOver: boolean) {
  hoverMenuItem(event.currentTarget, isOver)
}

export function handleThisMessageOver(event: MouseEvent<HTMLElement>, isOver: boolean) {
  hoverMenuItem(event.currentTarget, isOver, false)
}

export function handleBrandClick(event: MouseEvent<HTMLElement>) {
  switchToBrand(event.currentTarget)
}

export function handleThisMessageClick(event: MouseEvent<HTMLElement>) {
  dispatchDeskNavigation({ mode: 'msg', target: event.currentTarget })
}

export function handleReplyEditClick(event: MouseEvent<HTMLElement>) {
  void event
  showQuickReplyModal(0, false)
}

export function handleReplyClick() {
  dispatchEditorAction({ action: 'open-reply' })
}

export function handleEditGroupToggle(event: MouseEvent<HTMLElement>) {
  toggleEditButtonGroup(event.currentTarget)
}

export function handleEditClick() {
  dispatchEditorAction({ action: 'open-edit-message' })
}

export function handleNewMsgClick() {
  dispatchEditorAction({ action: 'open-new-message' })
}

export function handleSaveClick(event: MouseEvent<HTMLElement>) {
  dispatchEditorAction({ action: 'save', target: event.currentTarget, reason: 'portal-menu:before-save' })
}

export function handleMoreSettingsClick(event: MouseEvent<HTMLElement>) {
  dispatchEditorAction({ action: 'toggle-settings', target: event.currentTarget, tabId: -1 })
}

// The save/update label depends on the legacy body mode class.
export function editorSaveLabel(labels: PortalMenuActionLabels): string {
  const body = getMsgDeskRuntime().body?.classList
  if (!body) return labels.save
  if (body.contains('update_msg')) return labels.saveChanges
  if (body.contains('new_submsg')) return labels.saveMessage
  if (body.contains('new_answer')) return labels.saveAnswer
  return labels.save
}
